export default __webpack_public_path__ + "static/media/sanya.d352ff22.webp";